/*
 * Filtros locales de colección, en DOS MODOS y con la misma interfaz.
 *
 *   LOCAL   hasta 250 productos. Liquid pinta la colección entera con los valores de cada
 *           producto en `data-f1…N`, y aquí se oculta lo que no casa. Cero peticiones.
 *   REMOTO  por encima de 250. La colección no cabe en la página, así que el cruce lo hace
 *           el Worker de facetas contra su índice: devuelve HANDLES y recuentos, y las
 *           tarjetas se piden a Shopify con `/products/<handle>?view=card` — que es lo que
 *           garantiza que el precio sea el del cliente que ha entrado, porque los precios
 *           son B2B y ningún sitio fuera de Shopify puede calcularlos.
 *
 * Lo que comparten: los grupos son botones con las clases del tema (`btn btn--plain
 * btn--small`), el recuento de cada valor se calcula ignorando su propio filtro, y dentro
 * de un filtro los valores son OR mientras entre filtros es AND.
 *
 * En modo remoto los desplegables NO usan Alpine: los abre y cierra este fichero. Alpine
 * inicializa nodos añadidos, pero depender de eso para algo que se inyecta tras la carga es
 * pedir un fallo raro; con una clase se controla igual y no hay nada que pueda no arrancar.
 */

/* ─────────────────────────────────────────────────────────────────────────────
 * ESTADO EN LA URL — compartido por los dos modos
 * ─────────────────────────────────────────────────────────────────────────────
 * Sin esto los filtros no sobrevivían a recargar la página ni se podían enviar a nadie, que
 * en un catálogo técnico es la mitad de su utilidad: «mírate estos, los de 24 V y tamaño
 * S0» es un enlace, no una explicación.
 *
 * Formato `f=campo:valor` repetido, el MISMO que entiende el Worker, así que la URL de la
 * página y la de la consulta se leen igual. Se conservan los parámetros que ya hubiera
 * —`sort_by`, los `filter.p.*` de S&D— porque son de Shopify y no son nuestros para tocar.
 *
 * Se usa `replaceState`, no `pushState`: cada casilla marcada añadiría una entrada al
 * historial y volver atrás obligaría a pulsar diez veces para salir de la colección. El
 * precio es que atrás sale de la página en vez de deshacer un filtro — que es exactamente
 * lo que pasa hoy, así que no se empeora nada, y para deshacer está «Quitar filtros».
 */
function fltSlug(s) {
  return String(s).toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
function fltLeeUrl() {
  var p = new URLSearchParams(location.search);
  var sel = {};
  p.getAll('f').forEach(function (par) {
    var i = par.indexOf(':');
    if (i <= 0) return;
    var k = par.slice(0, i), v = par.slice(i + 1);
    if (!v) return;
    (sel[k] = sel[k] || {})[v] = true;
  });
  return { sel: sel, pagina: Math.max(1, parseInt(p.get('fp') || '1', 10) || 1) };
}
function fltEscribeUrl(sel, pagina) {
  var p = new URLSearchParams(location.search);
  p.delete('f'); p.delete('fp');
  Object.keys(sel).forEach(function (k) {
    Object.keys(sel[k]).forEach(function (v) { p.append('f', k + ':' + v); });
  });
  if (pagina > 1) p.set('fp', String(pagina));
  var q = p.toString();
  history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
}

(function () {
  var cfgEl = document.getElementById('flt-cfg');
  var caja = document.getElementById('flt');
  if (!cfgEl || !caja) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var orden = cfg.orden || [];
  var total = cfg.total || 0;

  var grupos = Array.prototype.slice.call(caja.querySelectorAll('.flt-g[data-idx]'));
  if (!grupos.length) return;
  var nFiltros = orden.length;

  /* El último número del valor. «0.00 bar … 10.00 bar» → 10. Es lo que permite ordenar los
     rangos de verdad: Liquid los ordena alfabéticamente y «0…4 bar» caía tras «0…250 bar».
     S&D tampoco sabe hacer esto. */
  var tope = function (v) {
    var n = String(v).match(/-?\d+(?:[.,]\d+)?/g);
    return n ? parseFloat(n[n.length - 1].replace(',', '.')) : Number.POSITIVE_INFINITY;
  };
  grupos.forEach(function (g) {
    if (orden[parseInt(g.getAttribute('data-idx'), 10)] !== 'num') return;
    var ops = Array.prototype.slice.call(g.querySelectorAll('.flt-o'));
    if (!ops.length) return;
    var padre = ops[0].parentNode;
    ops.sort(function (a, b) { return tope(a.getAttribute('data-v')) - tope(b.getAttribute('data-v')); })
       .forEach(function (o) { padre.appendChild(o); });
  });

  /* Un producto = sus dos envolturas + sus valores, agrupadas por el ID que puso Liquid.
     Deducir la clave del enlace de la tarjeta no vale: hay envolturas sin ningún enlace a
     producto, y con la clave mal el producto contaba doble y al ocultar una vista la otra
     se quedaba a la vista. */
  var items = [], porClave = {};
  Array.prototype.slice.call(document.querySelectorAll('#js-results [data-flt]')).forEach(function (n) {
    var clave = n.getAttribute('data-flt');
    var it = porClave[clave];
    if (!it) {
      it = { nodos: [], vals: [] };
      for (var i = 1; i <= nFiltros; i++) it.vals.push(n.getAttribute('data-f' + i) || '');
      porClave[clave] = it; items.push(it);
    }
    it.nodos.push(n);
  });
  if (!items.length) return;

  /* Las claves de la URL son el nombre del filtro pasado a minúsculas y sin acentos, no su
     posición: un índice cambiaría de significado en cuanto se añada o quite un filtro de la
     configuración, y los enlaces que alguien hubiera guardado empezarían a filtrar por otra
     cosa sin dar ningún error. */
  var claves = (cfg.etiquetas || []).map(fltSlug);
  var orden0 = cfg.orden || [];
  var elegido = [];
  for (var k = 0; k < nFiltros; k++) elegido.push({});
  (function () {
    var u = fltLeeUrl();
    claves.forEach(function (clave, i) {
      if (u.sel[clave]) elegido[i] = u.sel[clave];
    });
  })();
  var hayAlguno = function () {
    return elegido.some(function (s) { return Object.keys(s).length; });
  };

  /* Casa un producto con todo lo elegido, opcionalmente ignorando un filtro. Ignorar el
     propio filtro es lo que hace útiles sus recuentos: si el grupo «Rango» se contase a sí
     mismo, al marcar «10 bar» sus demás opciones saldrían todas a 0. */
  var casa = function (it, salvo) {
    for (var i = 0; i < elegido.length; i++) {
      if (i === salvo) continue;
      var s = elegido[i];
      if (Object.keys(s).length && !s[it.vals[i]]) return false;
    }
    return true;
  };

  var limpiar = document.getElementById('flt-limpiar');
  var cuenta = document.getElementById('flt-cuenta');

  var pinta = function () {
    var visibles = 0;
    items.forEach(function (it) {
      var ok = casa(it, -1);
      if (ok) visibles++;
      it.nodos.forEach(function (n) { n.classList.toggle('flt-oculto', !ok); });
    });

    grupos.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-idx'), 10);
      var sub = items.filter(function (it) { return casa(it, idx); });
      var n = {};
      sub.forEach(function (it) { var v = it.vals[idx]; if (v) n[v] = (n[v] || 0) + 1; });
      g.querySelectorAll('.flt-o').forEach(function (o) {
        var v = o.getAttribute('data-v'), c = n[v] || 0, marcado = !!elegido[idx][v];
        o.querySelector('.flt-o__n').textContent = '(' + c + ')';
        o.querySelector('input').disabled = c === 0 && !marcado;
      });
      var m = Object.keys(elegido[idx]).length;
      var eti = g.querySelector('.flt-g__n');
      if (eti) eti.textContent = m ? '(' + m + ')' : '';
    });

    if (limpiar) limpiar.hidden = !hayAlguno();
    if (cuenta) cuenta.textContent = hayAlguno()
      ? visibles + ' de ' + total + ' productos'
      : total + ' productos';
  };

  grupos.forEach(function (g) {
    var idx = parseInt(g.getAttribute('data-idx'), 10);
    g.querySelectorAll('.flt-o').forEach(function (o) {
      var v = o.getAttribute('data-v');
      var inp = o.querySelector('input');
      if (elegido[idx][v]) inp.checked = true;      // venía marcado en la URL
      inp.addEventListener('change', function (e) {
        if (e.target.checked) elegido[idx][v] = true; else delete elegido[idx][v];
        guardaUrl();
        pinta();
      });
    });
  });

  var guardaUrl = function () {
    var sel = {};
    claves.forEach(function (clave, i) {
      if (Object.keys(elegido[i]).length) sel[clave] = elegido[i];
    });
    fltEscribeUrl(sel, 1);
    var p = new URLSearchParams(location.search);
    if (orden && orden !== 'manual') p.set('fo', orden); else p.delete('fo');
    var q = p.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
  };

  /* ── Nuestro «Ordenar» ────────────────────────────────────────────────────
     Aquí es MÁS rico que en modo remoto: como la colección entera está en la página con las
     tarjetas ya pintadas por Shopify, el precio se lee del DOM y es exacto para el cliente
     que ha entrado, sin pedir nada a nadie. */
  var cajaOrden = document.getElementById('flt-orden');
  var orden = new URLSearchParams(location.search).get('fo') || 'manual';
  var opcionesOrden = [{ id: 'manual', etiqueta: 'Orden de la colección' },
                       { id: 'titulo:asc', etiqueta: 'Nombre: A → Z' },
                       { id: 'titulo:desc', etiqueta: 'Nombre: Z → A' },
                       { id: 'precio:asc', etiqueta: 'Precio: más bajo primero' },
                       { id: 'precio:desc', etiqueta: 'Precio: más alto primero' }];
  (cfg.etiquetas || []).forEach(function (et, i) {
    if (orden0[i] !== 'num') return;      // solo tiene sentido con valores numéricos
    opcionesOrden.push({ id: 'campo:' + i + ':asc', etiqueta: et + ': menor primero' });
    opcionesOrden.push({ id: 'campo:' + i + ':desc', etiqueta: et + ': mayor primero' });
  });

  /* El orden original, para poder volver a él. Los dos nodos de un producto se mueven
     juntos: si no, la vista de lista y la de rejilla acabarían intercaladas. */
  var ordenOriginal = items.slice();
  var num = function (v) {
    var m = String(v).match(/-?\d+(?:[.,]\d+)?/g);
    var u = m && m[m.length - 1];
    return u ? parseFloat(u.replace(',', '.')) : Number.POSITIVE_INFINITY;
  };
  var titulo = function (it) {
    var a = it.nodos[0] && it.nodos[0].querySelector('a[href*="/products/"]');
    return (a ? a.textContent : '').trim().toLowerCase();
  };
  var aplicaOrden = function () {
    var lista = ordenOriginal.slice();
    var m = /^campo:(\d+):(asc|desc)$/.exec(orden);
    if (orden === 'titulo:asc' || orden === 'titulo:desc') {
      lista.sort(function (a, b) { return titulo(a).localeCompare(titulo(b), 'es'); });
      if (orden === 'titulo:desc') lista.reverse();
    } else if (orden === 'precio:asc' || orden === 'precio:desc') {
      var pr = function (it) { return fltPrecioDeNodos(it.nodos); };
      lista.sort(function (a, b) { return pr(a) - pr(b); });
      if (orden === 'precio:desc') lista.reverse();
    } else if (m) {
      var i = parseInt(m[1], 10);
      lista.sort(function (a, b) {
        var x = num(a.vals[i]), y = num(b.vals[i]);
        /* Los que no tienen dato, al final en los dos sentidos: un producto sin valor no es
           «el más pequeño», y ponerlo primero hace que el listado parezca roto. */
        if (!isFinite(x) && !isFinite(y)) return 0;
        if (!isFinite(x)) return 1;
        if (!isFinite(y)) return -1;
        return m[2] === 'desc' ? y - x : x - y;
      });
    }
    var padre = document.getElementById('js-results');
    if (!padre) return;
    lista.forEach(function (it) {
      it.nodos.forEach(function (n2) { padre.appendChild(n2); });
    });
  };
  var pintaOrden = function () {
    if (!cajaOrden) return;
    fltPintaOrden(cajaOrden, opcionesOrden, orden, function (id) {
      orden = id; guardaUrl(); aplicaOrden(); pinta();
    });
  };

  if (limpiar) limpiar.addEventListener('click', function () {
    elegido = []; for (var i = 0; i < nFiltros; i++) elegido.push({});
    caja.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = false; });
    guardaUrl();
    pinta();
  });

  pintaOrden();
  if (orden !== 'manual') aplicaOrden();
  pinta();
})();

/* ─────────────────────────────────────────────────────────────────────────────
 * MODO REMOTO
 * ───────────────────────────────────────────────────────────────────────────── */
(function () {
  var cfgEl = document.getElementById('flt-cfg');
  var caja = document.getElementById('flt');
  if (!cfgEl || !caja) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.remoto) return;                      // el modo local ya se ha encargado

  var BASE = String(cfg.remoto).replace(/\/$/, '');
  var COL = cfg.coleccion;
  var POR = cfg.porPagina || 24;
  var bar = caja.querySelector('.flt__bar');
  var rejilla = document.getElementById('js-results');
  if (!bar || !rejilla) return;

  /* La rejilla que pintó Shopify. Se guarda para poder volver a ella al quitar los
     filtros, en vez de pedir otra vez lo mismo. */
  var original = rejilla.innerHTML;

  /* Qué plantilla hay que pedir para cada producto. Las colecciones van SIEMPRE en vista de
     lista —el conmutador rejilla/lista está apagado en todas las plantillas— así que esto no
     cambia durante la visita. Se sigue leyendo de la configuración y no se fija a mano: si
     algún día se vuelve a activar la rejilla en una colección, esto la sigue sola.

     Meter la tarjeta de rejilla en un contenedor de lista daba un producto por fila con la
     imagen a pantalla completa, que es lo que pasó el 22/8/2026. */
  var vista = cfg.vista === 'list' ? 'list' : 'grid';
  var plantilla = function () { return vista === 'list' ? 'fila' : 'card'; };
  /* Estado inicial desde la URL: recargar o abrir un enlace compartido debe reproducir el
     filtrado, no empezar de cero. Las claves son las del Worker, así que la URL de la página
     y la de la consulta se escriben igual. */
  var arranque = fltLeeUrl();
  var elegido = arranque.sel;                    // campo → {valor: true}
  var pagina = arranque.pagina;

  /* El orden lo elige el cliente con el desplegable del tema, que recarga la página con
     `sort_by`. Se le pasa al Worker, que ordena lo que puede: por PRECIO no, porque el
     precio depende del cliente y ordenar por el precio base daría un orden equivocado a
     quien tiene otros descuentos. Cuando el Worker responde que no lo admite, se dice. */
  var aviso = document.getElementById('flt-aviso');
  var cajaOrden = document.getElementById('flt-orden');
  var orden = new URLSearchParams(location.search).get('fo') || 'manual';
  var ordenes = [];

  /* Los dos por precio los añadimos nosotros: no salen del Worker porque el Worker no puede
     saber el precio del cliente. El orden lo dará Shopify y aquí se cruza. */
  var PRECIO = [
    { id: 'precio:asc', etiqueta: 'Precio: más bajo primero' },
    { id: 'precio:desc', etiqueta: 'Precio: más alto primero' },
  ];
  var esPrecio = function (o) { return o === 'precio:asc' || o === 'precio:desc'; };
  var sortByDe = function (o) { return o === 'precio:asc' ? 'price-ascending' : 'price-descending'; };
  var defs = [];                                 // los filtros tal como los da el Worker
  var abierto = null;

  var limpiar = document.getElementById('flt-limpiar');
  var cuenta = document.getElementById('flt-cuenta');
  var marcados = function () {
    var n = 0;
    for (var k in elegido) n += Object.keys(elegido[k]).length;
    return n;
  };
  /* La etiqueta activa del subtag va en TODAS las consultas: para el cliente el subtag es un
     filtro más, y sin ella el Worker contesta por la colección entera. */
  var TAGS = Array.isArray(cfg.tags) ? cfg.tags : [];

  var query = function () {
    var p = ['coleccion=' + encodeURIComponent(COL)];
    TAGS.forEach(function (t) { p.push('tag=' + encodeURIComponent(t)); });
    Object.keys(elegido).forEach(function (k) {
      Object.keys(elegido[k]).forEach(function (v) {
        p.push('f=' + encodeURIComponent(k + ':' + v));
      });
    });
    return p.join('&');
  };

  var guardaUrl = function () {
    fltEscribeUrl(elegido, pagina);
    /* El orden viaja en `fo`, aparte de los filtros: así un enlace compartido reproduce
       también cómo estaban ordenados. */
    var p = new URLSearchParams(location.search);
    if (orden && orden !== 'manual') p.set('fo', orden); else p.delete('fo');
    var q = p.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
  };

  var pedir = function (ruta) {
    var ctl = new AbortController();
    var t = setTimeout(function () { ctl.abort(); }, 12000);
    return fetch(BASE + ruta, { signal: ctl.signal })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .finally(function () { clearTimeout(t); });
  };

  /* ── La barra ────────────────────────────────────────────────────────────── */
  var cierra = function () {
    if (abierto) { abierto.setAttribute('data-abierto', '0'); abierto = null; }
  };
  document.addEventListener('click', function (e) { if (!caja.contains(e.target)) cierra(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cierra(); });

  var grupo = function (def) {
    var g = document.createElement('div');
    g.className = 'flex flex-none snap-start justify-center flt-g';
    g.setAttribute('data-idx', def.id);
    g.setAttribute('data-abierto', '0');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn--plain btn--small';
    btn.setAttribute('aria-expanded', 'false');
    var et = document.createElement('span'); et.textContent = def.etiqueta;
    var nn = document.createElement('span'); nn.className = 'ml-1 flt-g__n';
    btn.appendChild(et); btn.appendChild(nn);
    btn.insertAdjacentHTML('beforeend',
      '<span class="ml-1 flt-g__caret" aria-hidden="true"></span>');

    var panel = document.createElement('div');
    panel.className = 'flt-g__panel z-10 absolute min-w-[300px] max-w-lg overflow-hidden ' +
      'shadow-md border--radius border--width color__border-divider-1 color__bg-body left-0 top-14';
    var lista = document.createElement('div');
    lista.className = 'max-h-[50vh] overflow-y-auto';
    panel.appendChild(lista);

    def.valores.forEach(function (x) {
      var lab = document.createElement('label');
      lab.className = 'hover:color__bg-overlay-1 flex items-center break-all px-4 py-2 flt-o';
      lab.setAttribute('data-v', x.v);
      var inp = document.createElement('input');
      inp.type = 'checkbox'; inp.className = 'mr-2';
      inp.checked = !!(elegido[def.id] && elegido[def.id][x.v]);
      var txt = document.createElement('span'); txt.className = 'type--base flt-o__txt'; txt.textContent = x.t;
      var num = document.createElement('span'); num.className = 'type--base ml-1 opacity-75 flt-o__n';
      num.textContent = '(' + x.n + ')';
      inp.disabled = x.n === 0 && !inp.checked;
      inp.addEventListener('change', function () {
        elegido[def.id] = elegido[def.id] || {};
        if (inp.checked) elegido[def.id][x.v] = true; else delete elegido[def.id][x.v];
        pagina = 1;
        guardaUrl();
        refresca();
      });
      lab.appendChild(inp); lab.appendChild(txt); lab.appendChild(num);
      lista.appendChild(lab);
    });

    btn.addEventListener('click', function () {
      var yaAbierto = g.getAttribute('data-abierto') === '1';
      cierra();
      if (!yaAbierto) { g.setAttribute('data-abierto', '1'); abierto = g; }
      btn.setAttribute('aria-expanded', yaAbierto ? 'false' : 'true');
    });
    var m = elegido[def.id] ? Object.keys(elegido[def.id]).length : 0;
    nn.textContent = m ? '(' + m + ')' : '';
    if (m) btn.setAttribute('data-activo', '1');

    g.appendChild(btn); g.appendChild(panel);
    return g;
  };

  var pintaBarra = function () {
    /* Qué grupo estaba abierto, para volver a abrirlo. Al marcar un valor se repinta la
       barra entera —los recuentos de todos cambian— y sin esto el desplegable se cerraba en
       cada clic: en el móvil, donde son acordeones, obligaba a reabrirlo para marcar un
       segundo valor de la misma dimensión, que es justo lo que se hace todo el rato. */
    var abiertoId = abierto ? abierto.getAttribute('data-idx') : null;
    Array.prototype.slice.call(bar.querySelectorAll('.flt-g')).forEach(function (g) { g.remove(); });
    abierto = null;
    var antes = limpiar || cuenta;
    defs.forEach(function (d) {
      var g = grupo(d);
      bar.insertBefore(g, antes);
      if (abiertoId && d.id === abiertoId) {
        g.setAttribute('data-abierto', '1');
        abierto = g;
        var b = g.querySelector('button');
        if (b) b.setAttribute('aria-expanded', 'true');
      }
    });
    if (limpiar) limpiar.hidden = marcados() === 0;
  };

  /* ── Los resultados ──────────────────────────────────────────────────────── */
  var pager = document.createElement('div');
  pager.className = 'flt__pager flex items-center justify-center gap-2 py-6';
  pager.hidden = true;

  var pintaPager = function (total) {
    pager.innerHTML = '';
    var paginas = Math.ceil(total / POR);
    if (paginas <= 1) { pager.hidden = true; return; }
    pager.hidden = false;
    var boton = function (txt, destino, activo) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'btn btn--small ' + (activo ? 'btn--secondary' : 'btn--plain');
      b.textContent = txt;
      b.disabled = destino < 1 || destino > paginas || destino === pagina;
      b.addEventListener('click', function () {
        pagina = destino;
        guardaUrl();
        refresca(true);
        rejilla.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return b;
    };
    pager.appendChild(boton('‹ Anterior', pagina - 1, false));
    var info = document.createElement('span');
    info.className = 'type--small opacity-75';
    info.textContent = 'Página ' + pagina + ' de ' + paginas;
    pager.appendChild(info);
    pager.appendChild(boton('Siguiente ›', pagina + 1, false));
  };

  /* Las tarjetas, de Shopify. De 6 en 6 para no soltar 24 peticiones de golpe. */
  var tarjetas = function (handles) {
    var salida = new Array(handles.length);
    var i = 0;
    var uno = function () {
      var k = i++;
      if (k >= handles.length) return Promise.resolve();
      return fetch('/products/' + encodeURIComponent(handles[k]) + '?view=' + plantilla())
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; })
        .then(function (html) { salida[k] = html; return uno(); });
    };
    var hilos = [];
    for (var h = 0; h < 6; h++) hilos.push(uno());
    return Promise.all(hilos).then(function () { return salida.join(''); });
  };

  /* El scroll infinito del tema hay que apagarlo mientras se filtra. Su centinela llama a
     `fetchAndRenderPage('next')` al entrar en pantalla y añade la siguiente página de la
     colección SIN FILTRAR: con 6 resultados el centinela queda a la vista y detrás
     aparecía media colección. Se OCULTA, no se borra — `x-intersect` va por
     IntersectionObserver, que no dispara sobre algo con `display:none`, así que volver a
     mostrarlo no necesita que Alpine reinicialice nada. */
  var scrollInfinito = function (encendido) {
    document.querySelectorAll('[data-flt-paginacion]').forEach(function (n) {
      n.classList.toggle('flt-oculto', !encendido);
    });
  };

  var pintaOrden = function () {
    if (!cajaOrden) return;
    fltPintaOrden(cajaOrden, ordenes.concat(PRECIO), orden, function (id) {
      orden = id; pagina = 1; guardaUrl(); refresca();
    });
  };

  /* Se toma el mando de la rejilla cuando hay filtros O cuando hay un orden distinto del de
     la colección: en los dos casos lo que Shopify pintó ya no es lo que hay que ver. */
  var refresca = function (soloPagina) {
    var hay = marcados() > 0 || orden !== 'manual';
    scrollInfinito(!hay);
    if (cuenta) cuenta.textContent = 'buscando…';
    rejilla.style.opacity = '.4';

    if (!hay) {
      rejilla.innerHTML = original;
      rejilla.style.opacity = '';
      pager.hidden = true;
      if (cuenta) cuenta.textContent = cfg.total + ' productos';
      if (!soloPagina) cargaValores();
      if (limpiar) limpiar.hidden = true;
      return;
    }

    var q = query();
    var busca = esPrecio(orden)
      /* Por precio: se piden TODOS los handles que casan y el orden de precio que da
         Shopify, y se cruzan aquí. Hace falta el conjunto entero porque el más barato de los
         que casan puede estar en cualquier posición del orden de la colección. */
      ? Promise.all([pedir('/handles?' + q), fltRangosPrecio(COL, sortByDe(orden))])
          .then(function (r) {
            var lista = r[0].handles.slice(), rango = r[1];
            var pos = function (h) {
              var x = rango[h];
              return x === undefined ? Number.POSITIVE_INFINITY : x;
            };
            lista.sort(function (a, b) { return pos(a) - pos(b); });
            var ini = (pagina - 1) * POR;
            return { total: lista.length, todos: 0, ordenAdmitido: true,
                     handles: lista.slice(ini, ini + POR) };
          })
      : pedir('/buscar?' + q + '&pagina=' + pagina + '&por=' + POR +
              '&orden=' + encodeURIComponent(orden));

    Promise.all([
      busca,
      soloPagina ? Promise.resolve(null) : pedir('/valores?' + q),
    ]).then(function (res) {
      var b = res[0], v = res[1];
      if (v) {
        defs = v.filtros;
        if (v.ordenes) ordenes = v.ordenes;
        pintaBarra();
        pintaOrden();
      }
      /* El denominador sale del Worker, no de `collection.all_products_count`: así no pueden
         discrepar. Antes decían 2.277 y 2.280 porque la Admin API devolvía tres productos
         sin publicar que el escaparate no enseña. */
      var todos = b.todos || cfg.total;
      if (cuenta) cuenta.textContent = b.total + ' de ' + todos + ' productos';
      if (aviso) {
        /* Ya no hay orden que no se pueda aplicar —el precio lo resuelve Shopify—, pero el
           aviso se queda: si algún día llega un orden que el índice no sabe hacer, se dice
           en vez de fingir que ordenó. */
        var malOrden = b.ordenAdmitido === false;
        aviso.hidden = !malOrden;
        aviso.textContent = malOrden
          ? 'Ese orden no se puede aplicar al filtrar: se muestran en el orden de la colección.'
          : '';
      }
      pintaPager(b.total);
      if (!b.handles.length) {
        rejilla.innerHTML = '<p class="py-8 text-center type--base">Ningún producto con esos filtros.</p>';
        rejilla.style.opacity = '';
        return;
      }
      return tarjetas(b.handles).then(function (html) {
        rejilla.innerHTML = html;
        rejilla.style.opacity = '';
      });
    }).catch(function (e) {
      rejilla.style.opacity = '';
      if (cuenta) cuenta.textContent = 'no se pudo filtrar';
      /* Se deja la rejilla como estaba: mejor la lista completa que una página vacía. */
      console.warn('[filtros] ' + e);
    });
  };

  var cargaValores = function () {
    pedir('/valores?' + query()).then(function (v) {
      defs = v.filtros;
      if (v.ordenes) ordenes = v.ordenes;
      pintaBarra();
      pintaOrden();
      caja.hidden = false;
      if (cuenta && marcados() === 0) cuenta.textContent = cfg.total + ' productos';
    }).catch(function (e) {
      caja.hidden = true;                        // sin valores no se enseña una barra vacía
      console.warn('[filtros] ' + e);
    });
  };

  if (limpiar) limpiar.addEventListener('click', function () {
    /* Quita los FILTROS, no el orden: son dos cosas distintas y borrarle el orden a alguien
       que acaba de elegirlo es de las cosas que más molestan. */
    elegido = {}; pagina = 1; guardaUrl();
    if (aviso) aviso.hidden = true;
    refresca();
  });

  /* Ya no hay oyente del conmutador rejilla/lista: está apagado en todas las colecciones y
     la barra del tema no se pinta donde tenemos filtros propios, así que ese botón no
     existe. Si se vuelve a activar, hay que recuperar el oyente de `[data-flt-vista]`.
     Las marcas `data-flt-vista` siguen en `component__filter-bar` para eso. */

  caja.hidden = true;
  rejilla.parentNode.insertBefore(pager, rejilla.nextSibling);
  if (marcados() > 0 || orden !== 'manual') {
    /* La URL traía filtros: se pinta la barra y se busca de una vez, para que el visitante
       vea el resultado que le prometía el enlace y no la colección entera un instante. */
    cargaValores();
    refresca();
  } else {
    cargaValores();
  }
})();

/* ─────────────────────────────────────────────────────────────────────────────
 * NUESTRO «ORDENAR» — compartido por los dos modos
 * ─────────────────────────────────────────────────────────────────────────────
 * El «Ordenar» de Shopify recarga la página y reordena la colección COMPLETA, así que con
 * nuestros filtros puestos no sirve de nada: quien decide qué se ve es nuestro índice.
 *
 * EL PRECIO. No se puede indexar en nuestro Worker: es B2B y depende de la empresa del
 * cliente y de la familia de descuento de cada artículo, así que el mismo catálogo se ordena
 * distinto para dos clientes. Guardar un precio «base» daría un orden equivocado a casi
 * todos, y llevar el precio de cada cliente a un Worker público es la fuga que no queremos.
 *
 * Quien sí lo sabe es Shopify. Así que se le pregunta a él con
 * `?view=orden&sort_by=price-ascending`, que devuelve los handles de la colección en el
 * orden de precio DE ESE CLIENTE, y se cruza con los handles que casan con los filtros. El
 * resultado es exacto. Se pide una vez por sentido y se guarda mientras dure la visita.
 */
function fltRangosPrecio(coleccion, sortBy) {
  fltRangosPrecio.cache = fltRangosPrecio.cache || {};
  var clave = coleccion + '|' + sortBy;
  if (fltRangosPrecio.cache[clave]) return fltRangosPrecio.cache[clave];

  var url = function (p) {
    return '/collections/' + coleccion + '?view=orden&sort_by=' + sortBy +
      (p > 1 ? '&page=' + p : '');
  };
  var pide = function (p) {
    return fetch(url(p)).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) {
      var lin = t.split('\n').map(function (x) { return x.trim(); }).filter(Boolean);
      return { paginas: parseInt(lin[0], 10) || 1, handles: lin.slice(1) };
    });
  };
  var p = pide(1).then(function (uno) {
    if (uno.paginas <= 1) return uno.handles;
    var resto = [];
    for (var i = 2; i <= uno.paginas; i++) resto.push(pide(i));
    return Promise.all(resto).then(function (rs) {
      return uno.handles.concat.apply(uno.handles, rs.map(function (x) { return x.handles; }));
    });
  }).then(function (lista) {
    var r = {};
    lista.forEach(function (h, i) { r[h] = i; });
    return r;
  }).catch(function (e) {
    delete fltRangosPrecio.cache[clave];      // que un fallo no se cachee
    throw e;
  });
  fltRangosPrecio.cache[clave] = p;
  return p;
}

/** El precio que Shopify ya pintó en la tarjeta. Solo vale en modo local, donde están todas. */
function fltPrecioDeNodos(nodos) {
  for (var i = 0; i < nodos.length; i++) {
    var t = nodos[i].textContent || '';
    var m = t.match(/(\d{1,3}(?:\.\d{3})*),(\d{2})\s*(?:EUR|€)/);
    if (m) return parseFloat(m[1].replace(/\./g, '') + '.' + m[2]);
  }
  return Number.POSITIVE_INFINITY;            // sin precio, al final
}

/** El desplegable, con el marcado de botón del tema. */
function fltPintaOrden(caja, opciones, actual, alElegir) {
  caja.innerHTML = '';
  caja.setAttribute('data-abierto', '0');
  var sel = opciones.filter(function (o) { return o.id === actual; })[0] || opciones[0];

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn btn--plain btn--small';
  btn.setAttribute('aria-expanded', 'false');
  btn.innerHTML = '<span>Ordenar</span><span class="ml-1 flt-g__n"></span>' +
    '<span class="ml-1 flt-g__caret" aria-hidden="true"></span>';
  if (sel && sel.id !== 'manual') {
    btn.querySelector('.flt-g__n').textContent = '· ' + sel.etiqueta;
    btn.setAttribute('data-activo', '1');
  }

  var panel = document.createElement('div');
  panel.className = 'flt-g__panel z-10 absolute min-w-[300px] max-w-lg overflow-hidden ' +
    'shadow-md border--radius border--width color__border-divider-1 color__bg-body left-0 top-14';
  var lista = document.createElement('div');
  lista.className = 'max-h-[50vh] overflow-y-auto';
  panel.appendChild(lista);

  opciones.forEach(function (o) {
    var lab = document.createElement('label');
    lab.className = 'hover:color__bg-overlay-1 flex items-center break-all px-4 py-2';
    var inp = document.createElement('input');
    inp.type = 'radio'; inp.name = 'flt-orden'; inp.className = 'mr-2';
    inp.checked = o.id === actual;
    var txt = document.createElement('span');
    txt.className = 'type--base'; txt.textContent = o.etiqueta;
    inp.addEventListener('change', function () {
      caja.setAttribute('data-abierto', '0');
      alElegir(o.id);
    });
    lab.appendChild(inp); lab.appendChild(txt);
    lista.appendChild(lab);
  });

  btn.addEventListener('click', function () {
    var ab = caja.getAttribute('data-abierto') === '1';
    caja.setAttribute('data-abierto', ab ? '0' : '1');
    btn.setAttribute('aria-expanded', ab ? 'false' : 'true');
  });
  document.addEventListener('click', function (e) {
    if (!caja.contains(e.target)) caja.setAttribute('data-abierto', '0');
  });
  caja.appendChild(btn); caja.appendChild(panel);
}

/* ─────────────────────────────────────────────────────────────────────────────
 * MÓVIL: la barra se mete en el cajón del tema
 * ─────────────────────────────────────────────────────────────────────────────
 * El mismo patrón que usaba Search & Discovery: un botón «Filtrar y ordenar» a todo el ancho
 * que abre el cajón. Dentro NO se pinta una segunda copia de los filtros — se MUEVE la barra
 * entera. Duplicar el marcado obligaría a mantener dos veces la construcción de valores y de
 * recuentos, y una de las dos se queda atrás tarde o temprano.
 *
 * Se mueve con `matchMedia`, no con CSS, porque los desplegables de escritorio son paneles
 * `absolute` sobre la fila y en el cajón tienen que apilarse: son dos comportamientos, no dos
 * tamaños.
 */
(function () {
  var caja = document.getElementById('flt');
  var movil = document.getElementById('flt-movil');
  var ancla = document.getElementById('flt-ancla');
  if (!caja || !movil || !ancla) return;
  var bar = caja.querySelector('.flt__bar');
  if (!bar) return;

  var mq = window.matchMedia('(max-width: 767px)');
  var coloca = function () {
    /* Hay que QUITAR las utilidades de fila, no solo añadir las de columna: `flex-row` y
       `flex-col` de Tailwind tienen la misma especificidad, así que dejarlas las dos hace
       que gane la que esté después en la hoja y el resultado sea impredecible. */
    var fila = ['flex-row', 'flex-wrap', 'items-center', 'hidden', 'md:flex'];
    if (mq.matches) {
      if (bar.parentNode !== movil) movil.appendChild(bar);
      fila.forEach(function (c) { bar.classList.remove(c); });
      bar.classList.add('flt__bar--movil');
    } else {
      if (bar.parentNode !== caja) ancla.parentNode.insertBefore(bar, ancla.nextSibling);
      bar.classList.remove('flt__bar--movil');
      fila.forEach(function (c) { bar.classList.add(c); });
    }
  };
  coloca();
  if (mq.addEventListener) mq.addEventListener('change', coloca);
  else if (mq.addListener) mq.addListener(coloca);

  /* El número del botón que abre el cajón: cuántos filtros hay puestos. Se lee del propio
     marcado —los `(n)` que ya pinta cada grupo— para no duplicar la cuenta. */
  var nMovil = document.getElementById('flt-movil-n');
  var actualiza = function () {
    if (!nMovil) return;
    var n = 0;
    bar.querySelectorAll('.flt-g input[type=checkbox]:checked').forEach(function () { n++; });
    nMovil.textContent = n ? '(' + n + ')' : '';
  };
  bar.addEventListener('change', actualiza);
  /* La barra se repinta entera al cambiar los filtros en modo remoto, así que hay que
     recontar cuando eso pasa: un observador es más fiable que acordarse de llamarlo. */
  if (window.MutationObserver) {
    new MutationObserver(actualiza).observe(bar, { childList: true, subtree: true });
  }
  actualiza();
})();
